import { forwardRef } from 'react';
import { useIsChanel } from 'hooks/user/useIsBrand';
import ChanelProductItem from '../ChanelProductItem';
import ProductItem from './ProductItem';
import type { ProductItemProps } from './shared/types';

const ProductItemRenderer = forwardRef<HTMLDivElement, ProductItemProps>((props, ref) => {
    const isChanel = useIsChanel();

    if (isChanel) {
        return <ChanelProductItem ref={ref} {...props} />;
    }

    return <ProductItem ref={ref} {...props} />;
});

export default ProductItemRenderer;
